import classnames from 'classnames2';
import React from 'react';
import contentBlockBodyStyles from './ContentBlock.Body.scss';
export var createContentBlockBody = function createContentBlockBody() {
  for (var _len = arguments.length, styles = new Array(_len), _key = 0; _key < _len; _key++) {
    styles[_key] = arguments[_key];
  }

  var stylesMap = classnames(contentBlockBodyStyles.contentBlockBody, styles);

  var ContentBlockBodyBase = function ContentBlockBodyBase(props) {
    return React.createElement("div", {
      className: stylesMap
    }, props.children);
  };

  ContentBlockBodyBase.displayName = 'ContentBlock.Body';
  return ContentBlockBodyBase;
};
var Default = createContentBlockBody(contentBlockBodyStyles.default);
export var ContentBlockBody = Object.assign(Default, {
  Default: Default,
  Large: createContentBlockBody(contentBlockBodyStyles.large)
});